var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 48C0 21.4903 21.4903 0 48 0C74.5097 0 96 21.4903 96 48C96 74.5097 74.5097 96 48 96C21.4903 96 0 74.5097 0 48Z",
    fill: "url(#paint0_linear_139_2866)",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_139_2866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 48C16 30.3269 30.3269 16 48 16C65.6731 16 80 30.3269 80 48C80 65.6731 65.6731 80 48 80C30.3269 80 16 65.6731 16 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 48C16.5 30.603 30.603 16.5 48 16.5C65.397 16.5 79.5 30.603 79.5 48C79.5 65.397 65.397 79.5 48 79.5C30.603 79.5 16.5 65.397 16.5 48Z",
    stroke: "#E1E4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4 60C38.4 57.4539 39.4115 55.0121 41.2118 53.2118C43.0121 51.4114 45.4539 50.4 48 50.4C50.5461 50.4 52.9879 51.4114 54.7883 53.2118C56.5886 55.0121 57.6 57.4539 57.6 60H55.2C55.2 58.0904 54.4415 56.2591 53.0912 54.9088C51.7409 53.5586 49.9096 52.8 48 52.8C46.0905 52.8 44.2591 53.5586 42.9089 54.9088C41.5586 56.2591 40.8 58.0904 40.8 60H38.4ZM48 49.2C44.022 49.2 40.8 45.978 40.8 42C40.8 38.022 44.022 34.8 48 34.8C51.978 34.8 55.2 38.022 55.2 42C55.2 45.978 51.978 49.2 48 49.2ZM48 46.8C50.652 46.8 52.8 44.652 52.8 42C52.8 39.348 50.652 37.2 48 37.2C45.348 37.2 43.2 39.348 43.2 42C43.2 44.652 45.348 46.8 48 46.8Z",
    fill: "#525866"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_139_2866",
    x: 14,
    y: 15,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.0509804 0 0 0 0 0.0784314 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_139_2866"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_139_2866",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_139_2866",
    x1: 48,
    y1: 0,
    x2: 48,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717784"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717784",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/Account.bda21355c2ae27bfcd78a1c959ac8e36.svg";
export { ForwardRef as ReactComponent };